import { useEffect, useRef, useState } from 'react';
import fleetApi from '../../services/api.service';
import { buildUrlWithParams } from '../../utils/url.utils';

/**
 * Nombre d'envois AS400 par état (en attente, relance auto, intervention requise, envoyés),
 * avec les mêmes filtres de dates et de recherche que la liste.
 */
export default function useGetTourLogStats({ query, start_date, end_date }) {
  const [stats, setStats] = useState(null);
  const [reloadKey, setReloadKey] = useState(0);
  const abortControllerRef = useRef(null);

  useEffect(() => {
    abortControllerRef.current?.abort();
    const abortController = new AbortController();
    abortControllerRef.current = abortController;

    const params = Object.fromEntries(
      Object.entries({ query, start_date, end_date }).filter(
        ([, value]) => value
      )
    );
    const timeout = setTimeout(
      async () => {
        try {
          const response = await fleetApi.get(
            buildUrlWithParams('/tours/tours-logs/stats', params),
            { signal: abortController.signal }
          );
          setStats(response.data);
        } catch (error) {
          if (!abortController.signal.aborted) {
            setStats(null);
          }
        }
      },
      query ? 400 : 0
    );

    return () => {
      clearTimeout(timeout);
      abortController.abort();
    };
  }, [query, start_date, end_date, reloadKey]);

  return { stats, reload: () => setReloadKey((key) => key + 1) };
}
